import fillCrudMetadataGaps from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
export default fillCrudMetadataGaps({
  label: 'Cartão de Crédito',
  labelPlural: 'Cartões de Crédito',
  name: 'CreditCardToken',
  deletable: false,
  updatable: false,
  insertable: false,
  authorization: authorization('unauthenticated', false),
  dynamoDB: {
    tableName: 'SpearCreditCardToken',
    indexes: [{
      indexName: 'tenantId-personId-index',
      indexedProp: 'personId'
    }]
  },
  fields: [{
    label: 'Id',
    name: 'id',
    type: 'text',
    updatable: false,
    insertable: false,
    id: true,
    render: false
  }, {
    label: 'Pessoa',
    name: 'personId',
    type: 'text'
  }, {
    label: 'Data de expiração',
    name: 'expiryDate',
    type: 'text',
    insertable: false,
    updatable: false,
    required: true,
    render: i => {
      return i.expiryDate?.length === 4 ? i.expiryDate.substring(0, 2) + '/' + i.expiryDate.substring(2) : i.expiryDate;
    }
  }, {
    label: 'Número',
    name: 'maskedNumber',
    type: 'text',
    insertable: false,
    updatable: false
  }, {
    label: 'Bandeira',
    name: 'brand',
    type: 'text',
    insertable: false,
    updatable: false
  }, {
    label: 'Ativo',
    name: 'enabled',
    type: 'boolean',
    insertable: true,
    updatable: true,
    default: true
  }],
  filter: [{
    field: 'personId',
    op: 'eq'
  }]
});